import React from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';
import Body2 from '@joinforma/ui/components/Body2';

import { SettingsRoutes } from 'utils/routeGenerator';

const Container = styled.div`
  background-color: #e6f0ff;
  padding: 20px;
  text-align: center;
`;

const Description = styled(Body2)`
  display: block;
`;

interface Props {
  first_name: string;
}

const EmailBanner = ({ first_name }: Props) => (
  <Container>
    <Description>
      <b>{first_name}, We need your personal email address!</b> Why? To
      communicate with you about your tax saving benefits. Please go to{' '}
      <Link to={SettingsRoutes.profile()}>settings</Link> to update your
      profile.
    </Description>
  </Container>
);

export default EmailBanner;
